<template>
	<div class="c-controller-row c-station-slide" v-bind:class="{ active: active }">
		<div class="c-controller-column--small">
			<button class="c-controller-column-button" v-on:click.prevent="$emit('activate', slide)">
				<!-- TODO: completed indicator -->
				<span class="c-controller-indicator"></span>
				{{ slide.name }}
			</button>
		</div>
		<div class="c-controller-column--time">
				{{ slide.settings.duration || '' }}
		</div>
		<div class="c-controller-column">
			<p class="c-controller-column__title" v-if="subtitle">{{ subtitle }}</p>

			<div v-if="active" class="c-controller-content">
				<ul class="c-controller-column__list" v-if="listItems">
					<li v-for="item in listItems">{{ item }}</li>
				</ul>
				<component v-if="showControls" v-bind:is="slide.type" v-bind:slide="slide" v-on:subcommand="subcommand" />
				<button class="button c-station-slide__next" v-on:click="$emit('next', slide)">{{ slide.settings.next }}</button>
			</div>
		</div>
	</div>
</template>

<script>
import ChoosePlanet from './slides/ChoosePlanet';
import Questions from './slides/Questions';
import VideoSlide from './slides/VideoSlide';
import ImagesSlide from './slides/ImagesSlide';
import HmwSlide from './slides/HmwSlide';
import ExampleHmwSlide from './slides/HmwSlide';
import TextSlide from './slides/TextSlide';
import ResultsSlide from './slides/ResultsSlide';
import WhatIfSlide from './slides/WhatIfSlide';
import ExampleWhatIfSlide from './slides/WhatIfSlide';
import VoteSlide from './slides/VoteSlide';
import AnswerSlide from './slides/AnswerSlide';
import ScenarioPreviewSlide from './slides/ScenarioPreviewSlide';
import SingleColorPlanetSlide from './slides/SingleColorPlanetSlide';
import SingleColorSinglePlanetSlide from './slides/SingleColorSinglePlanetSlide';
import ScenarioSlide from './slides/ScenarioSlide';
import TeamPositionsSlide from './slides/TeamPositionsSlide';
import NieuwsmakerPresentationSlide from './slides/NieuwsmakerPresentationSlide';
import NieuwsmakerVoteSlide from './slides/NieuwsmakerVoteSlide';
import NieuwsmakerSlide from './slides/NieuwsmakerSlide';
import PitchSlide from './slides/PitchSlide';
import DiceExampleSlide from './slides/DiceExampleSlide';
import DiceSlide from './slides/DiceSlide';
import ChooseValuesSlide from './slides/ChooseValuesSlide';
import TeamQuestionSlide from './slides/TeamQuestionSlide';
import ShowTeamPositionsSlide from './slides/ShowTeamPositionsSlide';
import DiermocratieSlide from './slides/DiermocratieSlide';
import ScenarioVideoSlide from './slides/ScenarioVideoSlide';

export default {
	name: 'StationSlide',
	components: {
		ChoosePlanet,
		Questions,
		VideoSlide,
		ImagesSlide,
		HmwSlide,
		ExampleHmwSlide,
		TextSlide,
		ResultsSlide,
		VoteSlide,
		WhatIfSlide,
		ExampleWhatIfSlide,
		ScenarioPreviewSlide,
		ScenarioSlide,
		AnswerSlide,
		SingleColorPlanetSlide,
		SingleColorSinglePlanetSlide,
		TeamPositionsSlide,
		NieuwsmakerPresentationSlide,
		NieuwsmakerVoteSlide,
		NieuwsmakerSlide,
		PitchSlide,
		DiceExampleSlide,
		DiceSlide,
		ChooseValuesSlide,
		TeamQuestionSlide,
		ShowTeamPositionsSlide,
		DiermocratieSlide,
		ScenarioVideoSlide,
	},
	props: {
		slide: Object,
		currentSlide: Object,
	},
	computed: {
		active() {
			if (!this.currentSlide || !this.slide) {
				return false;
			}

			return this.slide.uuid == this.currentSlide.uuid;
		},
		showControls() {
			if (!this.$options.components[this.slide.type]) {
				return false;
			}
			return true;
		},
		subtitle() {
			return this.slide.settings?.description?.subtitle;
		},
		listItems() {
			return this.slide.settings?.description?.list;
		},
	},
	methods: {
		subcommand(name, data) {
			window.axios.post(`control/slide/${this.slide.uuid}/event`, {
				name,
				data,
			});
		},
	},
};
</script>

<style scoped></style>
